module.exports = __webpack_public_path__ + "static/backdrop-cta-2db5e5a0c944e2b16a11a18674570f76.jpeg";